import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("aaryavart_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e?.response?.status === 401) {
      localStorage.removeItem("aaryavart_token");
    }
    return Promise.reject(e);
  }
);

export const COMPANY = "Shree Aryavarta Developers";
export const WHATSAPP = "918224000921";
export const PHONES = [
  { display: "+91 82240 00921", tel: "+918224000921" },
  { display: "+91 82240 00902", tel: "+918224000902" },
  { display: "+91 98265 59347", tel: "+919826559347" },
];
export const PHONE_DISPLAY = PHONES[0].display;
export const EMAIL = "info@shreearyavartadevelopers.com";

export const formatINR = (n) => {
  if (n == null) return "—";
  // Indian numbering system (lakh/crore)
  if (n >= 10000000) return `₹ ${(n / 10000000).toFixed(2)} Cr`;
  if (n >= 100000) return `₹ ${(n / 100000).toFixed(2)} Lakh`;
  return `₹ ${n.toLocaleString("en-IN")}`;
};

export default api;
